import { render, staticRenderFns } from "./CreateMultiOrganAllocation.vue?vue&type=template&id=8aaa9d46"
import script from "./CreateMultiOrganAllocation.vue?vue&type=script&lang=js"
export * from "./CreateMultiOrganAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports